module.exports = "https://de18y2hs3hlxs.cloudfront.net/55a5b72b-ea57-45f3-9ae4-45ca394141b9/images/doctors.png?f2c36e418b5725f34aa32f105b6d7e41";